import Api from '.';
import { endpoints } from './endpoints';
export default class AppApi extends Api {

    init(data) {
        let url = this.buildUrl(endpoints.app.init)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    verifyOtp(data) {
        let url = this.buildUrl(endpoints.app.verifyOtp)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }



}